import { EmptyState } from '@westhetics/ui'
import { useState } from 'react'
import { Link } from 'react-router'
import { ListFooter } from '@/app/list-footer'
import { LoadError } from '@/app/load-error'
import { routes } from '@/routes'
import { useSessions } from './api'
import { SessionList, SessionListSkeleton } from './session-list'

const introClass = 'font-body text-secondary max-w-[640px] text-[13px] leading-[1.6] font-light'
const linkClass = 'text-ink border-hairline-heavy hover:border-ink border-b'

/**
 * Aba Acessos ("Seus acessos", RN-AUT-25, P-AUT-26): cada entrada na conta, com IP, do mais recente
 * para o mais antigo. A saída para quem não reconhece um acesso é a senha nova (RN-AUT-08).
 */
export function SessionsTab() {
  const [page, setPage] = useState(1)
  const sessions = useSessions(page)
  const items = sessions.data?.data ?? []

  return (
    <div className="flex max-w-[1120px] flex-col gap-4">
      <p className={introClass}>
        Cada entrada na sua conta fica registrada aqui: quando, como, de qual dispositivo e
        endereço. Se algum acesso não foi você,{' '}
        <Link to={routes.accountTab('password')} className={linkClass}>
          troque a senha
        </Link>
        : as outras sessões são encerradas na hora.
      </p>

      {sessions.isError ? (
        <LoadError
          title="Não conseguimos carregar seus acessos"
          error={sessions.error}
          onRetry={() => void sessions.refetch()}
        />
      ) : sessions.isPending ? (
        <SessionListSkeleton />
      ) : items.length === 0 ? (
        <EmptyState
          title="Nenhum acesso registrado ainda"
          description="O histórico começa na abertura da nova Westhetics; o que aconteceu no sistema antigo ficou lá."
        />
      ) : (
        <div>
          <SessionList sessions={items} showClinic />
          {sessions.data ? (
            <ListFooter
              meta={sessions.data.meta}
              noun={['acesso', 'acessos']}
              note="do mais recente para o mais antigo"
              onPage={setPage}
            />
          ) : null}
        </div>
      )}
    </div>
  )
}
